import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntitySidebar from 'components/EntitySidebar';

import { RoomSidebar_room$key } from '__generated__/RoomSidebar_room.graphql';

type Props = {
  room: RoomSidebar_room$key;
};

const RoomSidebar: FC<Props> = props => {
  const room = useFragment(
    graphql`
      fragment RoomSidebar_room on Room {
        ...EntitySidebar_entity
      }
    `,
    props.room
  );

  return <EntitySidebar entity={room}></EntitySidebar>;
};

export default RoomSidebar;
